import { FC, ReactNode } from 'react';
import { Portal } from '@radix-ui/react-portal';

import { DrawerContextProvider } from './context';
import { DrawerPanel } from './DrawerPanel';

type DrawerProps = {
  onClose: () => void;
  isExpanded: boolean;
  title: ReactNode;
  footer?: ReactNode;
  toolbar?: ReactNode;
};

export const Drawer: FC<React.PropsWithChildren<DrawerProps>> = ({
  children,
  onClose,
  isExpanded,
  title,
  footer,
  toolbar,
}) => {
  return (
    <DrawerContextProvider>
      <Portal asChild>
        <DrawerPanel
          onClose={onClose}
          isExpanded={isExpanded}
          title={title}
          footer={footer}
          toolbar={toolbar}
        >
          {children}
        </DrawerPanel>
      </Portal>
    </DrawerContextProvider>
  );
};
